import createApiClient from './apiClient';
import { cachedRequest, invalidateStudentCache } from '../utils/apiDataCache';

const studentApi = createApiClient(process.env.REACT_APP_ATHENIAN_STUDENT_SERVICE_URL);

export { invalidateStudentCache };

export const createStudent = (data) =>
  studentApi.post('/', data);

export const getStudents = (params) =>
  studentApi.get('/', { params });

export const getStudent = (studentId) =>
  cachedRequest(`student:${studentId}:detail`, () => studentApi.get(`/${studentId}`));

export const getAssessmentHistory = (studentId) =>
  studentApi.get(`/${studentId}/assessment-history`);

export const updateStudent = (studentId, data) => {
  invalidateStudentCache(studentId);
  return studentApi.put(`/${studentId}`, data);
};

export const deleteStudent = (studentId) => {
  invalidateStudentCache(studentId);
  return studentApi.delete(`/${studentId}`);
};

export const streamStudentProfileImage = async (studentId) => {
  const res = await studentApi.get(`/${studentId}/profile-image`, { responseType: 'blob' });
  return res.data;
};

export const uploadStudentProfileImage = (studentId, file) => {
  invalidateStudentCache(studentId);
  const form = new FormData();
  form.append('profile_image', file);
  return studentApi.post(`/${studentId}/profile-image`, form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};
